import request from '@/utils/superagent'
import handleAPIException from '@/utils/handleAPIException'

import APIS from '../apis'

export default {
  applyCheckPromotionCode: async function(product) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.APPLYCHECK_PROMOTIONCODE.method,
        APIS.PAY.APPLYCHECK_PROMOTIONCODE.path(product)
      ).end((err, res) => {
        if (err && res) {
          handleAPIException(res, () => {
            reject(res.body)
          })
          reject(res.body)
        } else {
          resolve(res.body)
        }
      })
    })
  },
  checkPromotionCode: async function(promotionCode, product) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.CHECK_PROMOTIONCODE.method,
        APIS.PAY.CHECK_PROMOTIONCODE.path(promotionCode, product)
      ).end((err, res) => {
        if (err && res) {
          handleAPIException(res, () => {
            reject(res.body)
          })
          reject(res.body)
        } else {
          resolve(res.body)
        }
      })
    })
  },
  checkPromotionTrial: async function(product) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.CHECK_PROMOTION_TRIAL.method,
        APIS.PAY.CHECK_PROMOTION_TRIAL.path(product)
      ).end((err, res) => {
        if (err && res) {
          handleAPIException(res, () => {
            reject(res.body)
          })
          reject(res.body)
        } else {
          resolve(res.body)
        }
      })
    })
  },
  checkServiceId: async function(urlPrefix, product) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.CHECK_SERVICE_ID.method,
        APIS.PAY.CHECK_SERVICE_ID.path()
      )
        .send({ urlPrefix, product })
        .end((err, res) => {
          if (err && res) {
            if (res.body) {
              const errorCode = res.body.errorCode ? res.body.errorCode : null
              if (errorCode === 'DUPLICATE_DATA') {
                resolve(res.body)
              }
            } else {
              handleAPIException(res, () => {
                reject(res.body)
              })
              reject(res.body)
            }
          } else {
            resolve(res.body)
          }
        })
    })
  },
  getServiceUnregisterBill: async function(billType, product) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.GET_UNREGISTER_BILL.method,
        APIS.PAY.GET_UNREGISTER_BILL.path(billType, product)
      ).end((err, res) => {
        if (err && res) {
          handleAPIException(res, () => {
            reject(res.body)
          })
          reject(res.body)
        } else {
          resolve(res.body)
        }
      })
    })
  },
  getMyServiceBill: async function(product) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.GET_MY_SERVICE_BILL.method,
        APIS.PAY.GET_MY_SERVICE_BILL.path(product)
      ).end((err, res) => {
        if (err && res) {
          handleAPIException(res, () => {
            reject(res.body)
          })
          reject(res.body)
        } else {
          resolve(res.body)
        }
      })
    })
  },
  // getMyServiceBillHistory: async function(serviceBillUid) {
  //   return new Promise((resolve, reject) => {
  //     request(
  //       APIS.PAY.GET_MY_SERVICE_BILL_HISTORY.method,
  //       APIS.PAY.GET_MY_SERVICE_BILL_HISTORY.path(serviceBillUid)
  //     ).end((err, res) => {
  //       if (err && res) {
  //         handleAPIException(res, () => {
  //           reject(res.body)
  //         })
  //         reject(res.body)
  //       } else {
  //         resolve(res.body)
  //       }
  //     })
  //   })
  // },
  createServiceBill: async function(serviceRequest) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.CREATE_SERVICE_BILL.method,
        APIS.PAY.CREATE_SERVICE_BILL.path()
      )
        .send(serviceRequest)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  createServiceSite: async function(serviceRequest) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.CREATE_SERVICE_SITE.method,
        APIS.PAY.CREATE_SERVICE_SITE.path()
      )
        .send(serviceRequest)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  createServiceTrial: async function(
    userName,
    telNumber,
    companyName,
    purpose,
    product
  ) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.CREATE_SERVICE_TRIAL.method,
        APIS.PAY.CREATE_SERVICE_TRIAL.path()
      )
        .send({
          userName,
          telNumber,
          companyName,
          purpose,
          product
        })
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  createServicePromotionAsk: async function(
    userName,
    telNumber,
    companyName,
    purpose,
    licenseCount,
    userPerStorage,
    startDate,
    endDate,
    externalLicenseCount,
    nxacAppUids,
    product
  ) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.CREATE_SERVICE_PROMOTION_ASK.method,
        APIS.PAY.CREATE_SERVICE_PROMOTION_ASK.path()
      )
        .send({
          userName,
          telNumber,
          companyName,
          purpose,
          licenseCount,
          userPerStorage,
          startDate,
          endDate,
          externalLicenseCount,
          nxacAppUids,
          product
        })
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  getPromotionList: async function(promotionInfo) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.GET_PROMOTION_LIST.method,
        APIS.PAY.GET_PROMOTION_LIST.path()
      )
        .send(promotionInfo)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  makePromotionCode: async function(
    promotionDay,
    licenseCount,
    externalLicenseCount,
    userPerStorage,
    validityTime,
    companyName,
    issuedNote,
    totalPrice,
    taxInvoiceDTO,
    product
  ) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.CREATE_PROMOTION.method,
        APIS.PAY.CREATE_PROMOTION.path()
      )
        .send({
          promotionDay,
          licenseCount,
          externalLicenseCount,
          userPerStorage,
          validityTime,
          companyName,
          issuedNote,
          totalPrice,
          taxInvoiceDTO,
          product
        })
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  updatePromotionCode: async function(promotionInfo) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.UPDATE_PROMOTION.method,
        APIS.PAY.UPDATE_PROMOTION.path()
      )
        .send(promotionInfo)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  getPriceList: async function(priceInfo) {
    return new Promise((resolve, reject) => {
      request(APIS.PAY.GET_PRICE_LIST.method, APIS.PAY.GET_PRICE_LIST.path())
        .send(priceInfo)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  getCountryCode: async function(contryCode) {
    return new Promise((resolve, reject) => {
      request(APIS.PAY.GET_COUNTRYCODE.method, APIS.PAY.GET_COUNTRYCODE.path())
        .send(contryCode)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  makePriceType: async function(
    priceType,
    priceName,
    userPerPrice,
    storeagePerPrice
  ) {
    return new Promise((resolve, reject) => {
      request(APIS.PAY.CREATE_PRICE.method, APIS.PAY.CREATE_PRICE.path())
        .send({ priceType, priceName, userPerPrice, storeagePerPrice })
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  getBillHistory: async function(offset, limit, order, product) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.GET_BILL_HISTORY.method,
        APIS.PAY.GET_BILL_HISTORY.path(offset, limit, order, product)
      ).end((err, res) => {
        if (err && res) {
          handleAPIException(res, () => {
            reject(res.body)
          })
          reject(res.body)
        } else {
          resolve(res.body)
        }
      })
    })
  },
  getBillHistoryUid: async function(serviceBillHisUid) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.GET_BILL_HISTORY_UID.method,
        APIS.PAY.GET_BILL_HISTORY_UID.path(serviceBillHisUid)
      ).end((err, res) => {
        if (err && res) {
          handleAPIException(res, () => {
            reject(res.body)
          })
          reject(res.body)
        } else {
          resolve(res.body)
        }
      })
    })
  },
  updateServiceName: async function(serviceUid, serviceName) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.UPDATE_SERVICE_NAME.method,
        APIS.PAY.UPDATE_SERVICE_NAME.path()
      )
        .send({
          serviceUid: serviceUid,
          serviceName: serviceName
        })
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  subscriptionsRevise: async function(id, subscriptionsReviseReq) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAYPAL.SUBSCRIPTIONS_REVISE.method,
        APIS.PAYPAL.SUBSCRIPTIONS_REVISE.path(id)
      )
        .send(subscriptionsReviseReq)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  getSubscription: async function(id) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAYPAL.GET_SUBSCRIPTION.method,
        APIS.PAYPAL.GET_SUBSCRIPTION.path(id)
      ).end((err, res) => {
        if (err && res) {
          handleAPIException(res, () => {
            reject(res.body)
          })
          reject(res.body)
        } else {
          resolve(res.body)
        }
      })
    })
  },
  subscriptionsCancel: async function(id, subscriptionsCancelReq) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAYPAL.SUBSCRIPTION_CANCEL.method,
        APIS.PAYPAL.SUBSCRIPTION_CANCEL.path(id)
      )
        .send(subscriptionsCancelReq)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  subscriptionsSuspend: async function(id, subscriptionsCancelReq) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAYPAL.SUBSCRIPTION_SUSPEND.method,
        APIS.PAYPAL.SUBSCRIPTION_SUSPEND.path(id)
      )
        .send(subscriptionsCancelReq)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  subscriptionsActivate: async function(id, subscriptionsCancelReq) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAYPAL.SUBSCRIPTION_ACTIVATE.method,
        APIS.PAYPAL.SUBSCRIPTION_ACTIVATE.path(id)
      )
        .send(subscriptionsCancelReq)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  getInicisData: async function(price) {
    return new Promise((resolve, reject) => {
      request(APIS.PAY.GET_INICIS_DATA.method, APIS.PAY.GET_INICIS_DATA.path())
        .send({ price })
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  getCashData: async function(product) {
    return new Promise((resolve, reject) => {
      request(APIS.PAY.GET_CASH.method, APIS.PAY.GET_CASH.path())
        .send(product)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  updateCashData: async function(rejectReq) {
    return new Promise((resolve, reject) => {
      request(APIS.PAY.UPDATE_CASH.method, APIS.PAY.UPDATE_CASH.path())
        .send(rejectReq)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  inicisSubscriptionsSuspend: async function(orderId, product) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.SUBSCRIPTION_SUSPEND.method,
        APIS.PAY.SUBSCRIPTION_SUSPEND.path(product)
      )
        .send(orderId)
        .end((err, res) => {
          console.log(res)
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  inicisSubscriptionsActivate: async function(orderId, product) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.SUBSCRIPTION_ACTIVATE.method,
        APIS.PAY.SUBSCRIPTION_ACTIVATE.path(product)
      )
        .send(orderId)
        .end((err, res) => {
          console.log(res)
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  inicisConfirm: async function(confirmRequest) {
    return new Promise((resolve, reject) => {
      request(APIS.PAY.CONFIRM_USER.method, APIS.PAY.CONFIRM_USER.path())
        .send(confirmRequest)
        .end((err, res) => {
          console.log(res)
          if (err && res) {
            handleAPIException(res, () => {
              console.log(res.body)
              reject(res.body)
            })

            console.log(res.body)
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  getServiceNXACList: async function(serviceUid) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.GET_SERVICE_NXAC_LIST.method,
        APIS.PAY.GET_SERVICE_NXAC_LIST.path(serviceUid)
      ).end((err, res) => {
        if (err && res) {
          handleAPIException(res, () => {
            console.log(res.body)
            reject(res.body)
          })

          console.log(res.body)
          reject(res.body)
        } else {
          resolve(res.body)
        }
      })
    })
  },
  setServiceNXACList: async function(serviceUid, setNXACReq) {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.SET_SERVICE_NXAC_LIST.method,
        APIS.PAY.SET_SERVICE_NXAC_LIST.path(serviceUid)
      )
        .send(setNXACReq)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              console.log(res.body)
              reject(res.body)
            })

            console.log(res.body)
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  getServiceTotalList: async function() {
    return new Promise((resolve, reject) => {
      request(
        APIS.PAY.GET_TOTAL_NXAC_LIST.method,
        APIS.PAY.GET_TOTAL_NXAC_LIST.path()
      ).end((err, res) => {
        if (err && res) {
          handleAPIException(res, () => {
            console.log(res.body)
            reject(res.body)
          })

          console.log(res.body)
          reject(res.body)
        } else {
          resolve(res.body)
        }
      })
    })
  },
  getNXACInfo: async function(nxacAppUid) {
    return new Promise((resolve, reject) => {
      request(APIS.PAY.GET_NXAC_INFO.method, APIS.PAY.GET_NXAC_INFO.path()).end(
        (err, res) => {
          console.log(res)
          if (err && res) {
            handleAPIException(res, () => {
              console.log(res.body)
              reject(res.body)
            })

            console.log(res.body)
            reject(res.body)
          } else {
            resolve(res.body)
          }
        }
      )
    })
  },
  createNXAC: async function(nxacInfo) {
    return new Promise((resolve, reject) => {
      request(APIS.PAY.CREATE_NXAC.method, APIS.PAY.CREATE_NXAC.path())
        .send(nxacInfo)
        .end((err, res) => {
          console.log(res)
          if (err && res) {
            handleAPIException(res, () => {
              console.log(res.body)
              reject(res.body)
            })

            console.log(res.body)
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  deleteNXAC: async function(nxacAppUid) {
    return new Promise((resolve, reject) => {
      request(APIS.PAY.DELETE_NXAC.method, APIS.PAY.DELETE_NXAC.path())
        .send(nxacAppUid)
        .end((err, res) => {
          console.log(res)
          if (err && res) {
            handleAPIException(res, () => {
              console.log(res.body)
              reject(res.body)
            })

            console.log(res.body)
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  updateNXAC: async function(nxacAppInfo) {
    return new Promise((resolve, reject) => {
      request(APIS.PAY.UPDATE_NXAC.method, APIS.PAY.UPDATE_NXAC.path())
        .send(nxacAppInfo)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  changeManagerId: async function(managerLog) {
    return new Promise((resolve, reject) => {
      request(APIS.PAY.CHANGE_MANAGER.method, APIS.PAY.CHANGE_MANAGER.path())
        .send(managerLog)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/Pay.js